module.exports = __webpack_public_path__ + "static/media/Michelle_Adriana_Rosas_Gonzalez.f20af564.png";